// Annuaire léger des utilisateurs (avatars) — chargé une fois, partagé par toute l'app.
import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
let inflight = null;
const listeners = new Set();

function notify() { listeners.forEach((fn) => fn(cache)); }

export function loadUserDirectory(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (inflight && !force) return inflight;
  inflight = api.get("/users/directory")
    .then(({ data }) => {
      const users = Array.isArray(data) ? data : [];
      const byId = {};
      users.forEach((u) => { byId[u.id] = u; });
      cache = { users, byId, loaded: true };
      notify();
      return cache;
    })
    .catch(() => {
      cache = cache || { users: [], byId: {}, loaded: true, error: true };
      notify();
      return cache;
    })
    .finally(() => { inflight = null; });
  return inflight;
}

export function invalidateUserDirectory() { cache = null; return loadUserDirectory(true); }

/** iter424 pt 2 — seuls les comptes actifs (ni bloqués, ni inactifs, ni supprimés) sont proposés dans les sélecteurs. */
export const selectableUsers = (list) => (Array.isArray(list) ? list : []).filter((u) => u && (u.selectable ?? (u.status === "active" && !u.is_deleted && !u.archived_at)));

const EMPTY = { users: [], byId: {}, loaded: false };

/** useUserDirectory() → { users, byId, loaded, active } */
export function useUserDirectory() {
  const [state, setState] = useState(cache || EMPTY);
  useEffect(() => {
    const fn = (c) => setState(c);
    listeners.add(fn);
    loadUserDirectory();
    return () => listeners.delete(fn);
  }, []);
  return { ...state, active: state.users.filter((u) => u.is_active) };
}
